<template>
  <div>
    <div
      class="flex flex-col items-center justify-center rounded-lg shadow-xs border px-5 py-5 transition-all duration-300 ease-linear"
    >
      <p class="font-light text-xs lg:text-sm">Amount</p>
      <h3 class="text-2xl mt-1">
        {{
          parseMoneyAll(transactionDetails.amount, transactionDetails.currency)
        }}
      </h3>
      <p class="flex items-center gap-x-3 mt-2">
        <span class="border-b border-solid border-gray-200 w-10 lg:w-24"></span>
        <span
          @click="toggleShow('showBreakDown')"
          class="font-light text-xs lg:text-sm text-primary flex items-center gap-x-1 cursor-pointer"
          ><span>See Breakdown</span>
          <div
            class="transition-all duration-300 transform"
            :class="showBreakDown ? '-rotate-90' : 'rotate-90'"
          >
            <arrow-right-icon />
          </div>
        </span>
        <span class="border-b border-solid w-10 lg:w-24 border-gray-200"></span>
      </p>
      <transition name="fade-in">
        <ul
          v-if="showBreakDown"
          class="w-full text-xs lg:text-sm font-light px-2 lg:px-4 mt-4 text-root-4"
        >
          <li class="flex items-center justify-between mb-4">
            <span>Our fees {{ `${0}%` }}</span>
            <span>{{ `${'USD'} ${addComma('0')}` }}</span>
          </li>
          <li class="flex items-center justify-between mb-4">
            <span>Amount converted</span>
            <span>
              {{ 'USD' }}
              {{ addComma((0).toFixed(2)) }}</span
            >
          </li>
          <li class="flex items-center justify-between mb-4">
            <span>Exchange rate</span>
            <div>
              <div>
                <div class="text-root-4">
                  {{ 'USD' }}
                  {{ 0 }}
                </div>
              </div>
            </div>
          </li>
          <li class="flex items-center justify-between mb-4">
            <span>Recipient would receive</span>
            <span class="font-semibold">{{ parseMoneyAll(0, 'USD') }}</span>
          </li>
        </ul>
      </transition>
    </div>
    <ul class="font-light text-xs lg:text-sm px-5">
      <li
        class="grid grid-cols-2 capitalize items-center border-b py-3.5 lg:py-6"
      >
        <span>Time & Date</span>
        <span>{{
          parseRelativeTime(transactionDetails.transferCreatedAt)
        }}</span>
      </li>
      <!-- <div>
        <li
          class="grid grid-cols-2 items-center font-normal text-sm border-b py-3.5 lg:py-6"
        >
          <span>From</span>
          <span class="flex items-center gap-x-2">
            <currency-icons :currency="getCurrencyCountry('NGN')" />
            <span class="capitalize">{{ '-' }}</span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 items-center border-b font-normal text-sm py-3.5 lg:py-6"
        >
          <span>To</span>
          <span class="flex items-center gap-x-2">
            <currency-icons :currency="getCurrencyCountry('USD')" />
            <span class="capitalize">{{ '-' }}</span>
          </span>
        </li>
      </div> -->
      <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
        <span>Transaction ID</span>
        <span
          >{{ maskID(transactionDetails.id) || '--' }}
          <span
            class="cursor-pointer mb-1 ml-2"
            v-clipboard:copy="transactionDetails.id"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </span>
        </span>
      </li>
      <!-- no data returned -->
      <!-- <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
        <span>Payment Method</span>
        <span class="flex items-center gap-x-2">
          <span class="capitalize">{{
            formatServerName(transactionDetails.fundsTransferMethod || '-')
          }}</span>
        </span>
      </li> -->
      <li class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6">
        <span>Status</span>
        <span class="flex items-center gap-x-2">
          <span
            :class="statusClass(transactionDetails.status)"
            class="py-1.5 px-3 rounded-lg flex items-center gap-1"
            >{{ transactionDetails.status }}</span
          >
        </span>
      </li>
      <!-- commented out to be updated when BE sends data -->
      <!-- reason -->
      <!-- <li
        class="flex justify-between items-center border-b py-3.5 lg:py-5 cursor-pointer"
        @click="toggleShow('showReasonForTransfer')"
      >
        <span>Reason for transfer</span>
        <span class="text-primary font-semibold text-xl">{{
          showReasonForTransfer ? '-' : '+'
        }}</span>
      </li> -->
      <!-- <transition name="slide-fade">
        <div v-if="showReasonForTransfer">
          <li class="items-center border-b py-3.5 lg:py-5 bg-gray-100 px-3">
            <span style="word-break: normal">{{ '-' }}</span>
          </li>
        </div>
      </transition> -->
      <li
        class="flex justify-between items-center border-b py-3.5 lg:py-5 cursor-pointer"
        @click="toggleShow('showReference')"
      >
        <span>Reference</span>
        <span class="text-primary font-semibold text-xl">{{
          showReference ? '-' : '+'
        }}</span>
      </li>
      <transition name="slide-fade">
        <div v-if="showReference">
          <li class="items-center border-b py-3.5 lg:py-5 bg-gray-100 px-3">
            <span style="word-break: normal">{{
              transactionDetails.reference
            }}</span>
          </li>
        </div>
      </transition>
      <li
        class="flex justify-between items-center border-b py-3.5 lg:py-5 cursor-pointer"
        @click="toggleShow('showIntermediaryDetails')"
      >
        <span>Intermediary Bank Details</span>
        <span class="text-primary font-semibold text-xl">{{
          showIntermediaryDetails ? '-' : '+'
        }}</span>
      </li>
      <transition name="slide-fade">
        <div v-if="showIntermediaryDetails">
          <div
            v-for="(item, index) in bankDetails"
            :key="index"
            class="flex flex-row border rounded-md py-3.5 lg:py-5 bg-surface px-3 justify-between items-center mb-3"
          >
            <p class="text-sm font-thin">{{ item.key }}</p>
            <div class="flex items-center gap-x-3">
              <p class="text-xs font-semibold">{{ item.value || '--' }}</p>
              <div
                class="cursor-pointer mb-1 ml-2"
                v-clipboard:copy="item.value"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <copy-icon />
              </div>
            </div>
          </div>
        </div>
      </transition>
      <li class="flex justify-between items-center border-b py-3.5 lg:py-6">
        <span>Recipient Details</span>
        <arrow-right-icon @click.native="changePage" class="cursor-pointer" />
      </li>
    </ul>
  </div>
</template>

<script>
import {
  MaskWalletAddressTwo,
  AddComma,
  ParseLocalTime,
  ParseMoney,
  ParseMoneyAll,
  ParseRelativeTime,
  GetCurrencyCountry,
  FormatServerName,
  StatusClass
} from '@/utils/helpers.js'
import app from '@/mixins/app.js'

export default {
  name: 'TransferDrawer',
  mixins: [app],
  props: {
    transactionDetails: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showReasonForTransfer: false,
      showTransferDocument: false,
      showInitiatorDetails: false,
      isLoading: false,
      showDepositDetails: false,
      showBreakDown: false,
      documentsUploaded: [],
      imageUrl: null,
      fileName: '',
      formData: null,
      showReference: false,
      showIntermediaryDetails: false
    }
  },
  components: {
    ArrowRightIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    // Transition: () =>
    //   import('@/components/v2/animation/transition/Transition.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
    // CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  computed: {
    bankDetails () {
      return [
        {
          key: 'Bank Name',
          value:
            this.transactionDetails.transferInstruction.bankDetails.bankName ||
            '--'
        },
        {
          key: 'Account Number',
          value:
            this.transactionDetails.transferInstruction.bankDetails
              .accountNumber || '--'
        },
        {
          key: 'Account Name',
          value:
            this.transactionDetails.transferInstruction.bankDetails
              .accountName || '--'
        },
        {
          key: 'Country',
          value:
            this.transactionDetails.transferInstruction.bankDetails.country ||
            '--'
        },
        {
          key: 'Bank Address',
          value:
            this.transactionDetails.transferInstruction.bankDetails
              .bankAddress || '--'
        },
        {
          key: 'isWithinUS',
          value:
            this.transactionDetails.transferInstruction.bankDetails
              .isWithinUS || '--'
        },
        {
          key: 'Routing Number',
          value:
            this.transactionDetails.transferInstruction.bankDetails
              .routingNumber || '--'
        }
      ]
    },
    displayTimeDate () {
      const timeToPick =
        this.transactionInfo?.transferStatus === this.$STATUS.COMPLETED
          ? this.transactionInfo?.transferCompletedAt
          : this.transactionInfo?.transferCreatedAt

      return this.tooltipDateContent(timeToPick)
    }
  },
  methods: {
    parseRelativeTime (time) {
      return ParseRelativeTime(time)
    },
    statusClass (status) {
      return StatusClass(status)
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    toggleShow (arg) {
      this[arg] = !this[arg]
    },
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    handleClose () {
      this.$emit('close')
    },
    addComma (val) {
      return AddComma(val.toString())
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    parseLocalTime (time) {
      return ParseLocalTime(time)
    },
    parseMoney (amount) {
      return ParseMoney(amount)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    changePage () {
      this.$emit('changeActiveComponent', 'recipient-details')
    }
  }
}
</script>
